export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-1440w.7e27570c.avif";